"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var JWT = require("jwt-decode");
var OidcTokenBase = /** @class */ (function () {
    function OidcTokenBase(token) {
        var _this = this;
        this.toString = function () { return _this.token; };
        this.getClaim = function (claim) { return _this.tokenObj[claim]; };
        this.token = token;
        this.tokenObj = JWT(this.token);
    }
    return OidcTokenBase;
}());
exports.OidcTokenBase = OidcTokenBase;
//# sourceMappingURL=OidcTokenBase.js.map